module.exports = __webpack_public_path__ + "static/media/icon_partners.6ac1a296.svg";